const $ = require('jquery');

function getElementsWithMatchingFilter(contextId, name, value) {
  const els = [];
  const $context = contextId ? $(`#${contextId}`) : $('body');
  const $filterables = $context.find(
    `.filter-element[data-filter-name="${name}"]`
  );
  if (value === '*') {
    $filterables.each((index, el) => {
      els.push(el);
    });
  } else {
    const values = value.split(',');
    for (let i = 0; i < values.length; i += 1) {
      $filterables
        .filter(`[data-filter-value="${values[i]}"]`)
        .each((index, el) => {
          els.push(el);
        });
    }
  }
  return els;
}

function applyFilter(event) {
  const $this = $(event.target);
  const filterName = $this.data('filter-name');
  const contextId = $this.data('context-id');
  const $context = contextId ? $(`#${contextId}`) : $('body');

  $context
    .find(`.filter-trigger[data-filter-name="${filterName}"]`)
    .removeClass('active');
  $this.addClass('active');

  $context
    .find(`.filter-element[data-filter-name="${filterName}"]`)
    .addClass('hidden');

  getElementsWithMatchingFilter(
    contextId,
    filterName,
    `${$this.data('filter-value')}`
  ).forEach((el) => {
    $(el).removeClass('hidden');
  });
}

function initGroup($group) {
  if ($group.data('filter-initialized') === true) {
    return;
  }
  $group.data('filter-initialized', true);
  $group.find('.filter-trigger').on('click', (event) => {
    applyFilter(event);
  });
  $group.find('.filter-trigger.active').trigger('click');

  $group.find('.filter-trigger.active').each((i1, activeTrigger) => {
    const filterName = $(activeTrigger).data('filter-name');
    const contextId = $(activeTrigger).data('context-id');
    $group
      .find(`.filter-trigger[data-filter-name="${filterName}"]`)
      .each((i2, trigger) => {
        const count = getElementsWithMatchingFilter(
          contextId,
          filterName,
          `${$(trigger).data('filter-value')}`
        ).length;
        const text = $(trigger).text();
        $(trigger).text(`${text} (${count})`);
      });
  });
}

function checkGroups(countNo) {
  $('.filter-group').each((i, group) => {
    const $group = $(group);
    if ($group.parents('.hidden').length) {
      window.setTimeout(() => {
        checkGroups(countNo + 1);
      }, countNo * 100);
      return;
    }
    initGroup($group);
  });
}
window.addEventListener('load', function () {
  checkGroups(1);
});
